import type { AxiosInstance } from 'axios';

type sendNotification = {
  type: 'email' | 'sms' | 'whatsapp',
  action: String,
  customerId?: String,
  reservationId?: String,
  expectedSendOutDate?: String,
}

class NotificationService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  public async sendNotification({ type, action, customerId, reservationId, expectedSendOutDate }: sendNotification) : Promise<void> {
    await this.client.post('/notifications', {
      action,
      type,
      customerId,
      reservationId,
      expectedSendOutDate: expectedSendOutDate || new Date().toISOString(),
    });
  }
}

export { NotificationService };
